import { GetterTree } from "vuex"
import { RootState } from "../../index"
import { State } from "./state"

export type Getters = {
    getIsManuallySelected(state: State): boolean
    getSelectedDataRegion(state: State): string
    getDefaultRegion(state: State): string
}

export const getters: GetterTree<State, RootState> & Getters = {
    getIsManuallySelected(state) {
        return state.isManuallySelected
    },
    getSelectedDataRegion(state) {
        return state.selectedDataRegion
    },
    getDefaultRegion(state) {
        return state.defaultRegion
    },
}
